import React from "react";
import {
  DeleteButton,
  Edit,
  SaveButton,
  Toolbar,
  useRecordContext,
  type EditProps,
} from "react-admin";
import { FmbContributionCategoryForm } from "./FmbContributionCategoryForm";

const EditToolbar = () => {
  const record = useRecordContext();
  const isSystem = Boolean(record?.isSystem);

  return (
    <Toolbar>
      <SaveButton />
      {!isSystem && <DeleteButton mutationMode="pessimistic" />}
    </Toolbar>
  );
};

export default function FmbContributionCategoryEdit(props: EditProps) {
  return (
    <Edit {...props} mutationMode="pessimistic" title="Edit Contribution Category">
      <FmbContributionCategoryForm toolbar={<EditToolbar />} />
    </Edit>
  );
}
